<template>
  <div
    class="guarantee-item"
    v-for="guarantee in guaranteeText"
    :key="guarantee.id"
  >
    <p>{{ guarantee }}</p>
  </div>
</template>

<script>
export default {
  name: "project-guarantee-item",
  props: {
    guaranteeText: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.guarantee-item {
  background: url("@/assets/images/contur-about.png");
  background-repeat: no-repeat;
  background-size: contain;
  height: 89px;
  width: 100%;
  position: relative;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    height: 48px;
    padding: 7px;
  }

  @media (min-width: 767px) and (max-width: 1360px) {
    height: 110px;
  }

  p {
    font-family: "UAF Sans HR", serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    max-width: 445px;
    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 18px;
    }

    @media (min-width: 767px) and (max-width: 1360px) {
      max-width: 100%;
    }
  }
}
</style>
